import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/forgot-password-screen';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import { resetPassword } from '../../api/authentication.ts';
import { FORM_ERRORS } from '../../constants/form_errors.ts';

function ForgotPassword() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [isErrored, setIsErrored] = useState(false);

  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      email_address: '',
    },
    validate: {
      email_address: (value) => (/^\S+@\S+$/.test(value) ? null : FORM_ERRORS.EMAIL_INVALID),
    },
  });

  const handleSubmit = (values: typeof form.values) => {
    setIsLoading(true);
    resetPassword({ email: values.email_address }, '')
      .then(() => {
        setIsLoading(false);
        setIsSuccessful(true);
      })
      .catch((error) => {
        console.error('Error submitting forgot password form', JSON.stringify(error));
        setIsLoading(false);
        setIsSuccessful(false);
        setIsErrored(true);
      });
  };

  return (
    <Screen form={form} handleSubmit={handleSubmit} isLoading={isLoading} success={isSuccessful} error={isErrored} />
  );
}

export default ForgotPassword;
